exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p[data-v-7f089d07]{margin-bottom:.3rem!important}table td[data-v-7f089d07]{padding-left:.3rem;padding-right:.3rem}", ""]);

// exports
